import { connect } from 'react-redux'
import Resolution from './resolution'
import {
  getConflicts,
  getRefetchRequest,
  getResolveRequest,
  getRetireRequest
} from '../../../../../../stores/conflict-resolution/conflict-resolution.selectors'
import {
  retireStudent,
  refetchConflicts,
  resolveConflict
} from '../../../../../../stores/conflict-resolution/conflict-resolution.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me, meRequest }) => {
  const conflicts = getConflicts(state)
  return {
    processing:
      getRefetchRequest(state).pending ||
      getResolveRequest(state).pending ||
      getRetireRequest(state).pending,
    schoolId:
      me &&
      !meRequest.pending &&
      me.account.teacher_type &&
      me.account.teacher_type.school &&
      me.account.teacher_type.school.id,
    remainingStudents: conflicts && conflicts.remaining,
    importedStudentsCount: conflicts && conflicts.imported_students_count,
    similarStudentResolved:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.similar_resolved,
    studentId:
      conflicts && conflicts.legacy_student && conflicts.legacy_student.id,
    studentName:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.full_name,
    studentDay:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.student_type &&
      conflicts.legacy_student.student_type.dob_day &&
      conflicts.legacy_student.student_type.dob_day,
    studentMonth:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.student_type &&
      conflicts.legacy_student.student_type.dob_month &&
      conflicts.legacy_student.student_type.dob_month,
    workCount:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.student_type &&
      conflicts.legacy_student.student_type.all_works_count,
    groups:
      conflicts &&
      conflicts.legacy_student &&
      conflicts.legacy_student.student_type &&
      conflicts.legacy_student.student_type.groups &&
      conflicts.legacy_student.student_type.groups
        .map(group => group.title)
        .join(', '),
    unmatchingStudents:
      conflicts && conflicts.non_matched_pull_provider_students
  }
}

const mapDispatchToProps = dispatch => ({
  onResolve: (schoolId, matchingStudentId, legacyStudentId) =>
    new Promise((resolve, reject) =>
      dispatch(resolveConflict(schoolId, matchingStudentId, legacyStudentId))
        .then(() => dispatch(refetchConflicts(schoolId)))
        .then(() => resolve())
    ).catch(errorHandler),
  onRetire: (studentId, schoolId) =>
    dispatch(retireStudent(studentId))
      .then(() => dispatch(refetchConflicts(schoolId)))
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Resolution)
)
